import { $t } from 'hooks/i18n';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataSource } from 'components/DataSource';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
import MasterDetailPages from './MasterDetailPages';
const VwclosingbalanceBranchListPage = (props) => {
		const utils = useUtils();
	const filterSchema = {
		branchcode: {
			tagTitle: $t('branchCode'),
			value: '',
			valueType: 'single',
			options: [],
		},
		groupname: {
			tagTitle: $t('groupName'),
			value: '',
			valueType: 'single',
			options: [],
		},
		search: {
			tagTitle: $t('search'),
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, apiUrl, currentRecord, sortBy, sortOrder, apiRequestError, getPageBreadCrumbs, onSort, setCurrentRecord, pagination } = pageController;
	const { filters, setFilterValue, setFilterOptions } = filterController;
	const { totalPages, currentPage, limit, setPrevPage, setNextPage } =  pagination;
	function PhonenumberTemplate(data){
		if(data){
			return (
				<>{ data.users_phonenumber }</>
			);
		}
	}
	function UseridTemplate(data){
		if(data){
			return (
				<>{ data.users_userid }</>
			);
		}
	}
	function MasterDetailBtnTemplate(data){
		if(data){
			return (
				<><Button className="p-button-text" onClick={()=>setCurrentRecord(data)} icon="pi pi-caret-down" label="" /></>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div  className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">{$t('loading')}</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					{$t('noRecordFound')}
				</div>
			);
		}
	}
	function ExportData() {
		if (props.exportData && records.length) {
			const downloadFileName = `${utils.dateNow()}-vwclosingbalance`;
			return (
				<div className="m-2">
					<ExportPageData  pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel={$t('')} tooltip={$t('export')} buttonIcon="pi pi-print" />
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
	return (
		<div className="flex-grow-1">
			<div className="flex  justify-content-center">
				<div  className="m-2">
					<Button disabled={pagination.currentPage <= 1} label="Previous" onClick={()=>pagination.setPrevPage()} icon="pi pi-arrow-left" />
				</div>
				<div className="m-2">
					<Button disabled={pagination.currentPage >= totalPages} label="Next" onClick={()=>pagination.setNextPage()} icon="pi pi-arrow-right" icon-pos="right" />
				</div>
			</div>
		</div>
	)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
				<ExportData />
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="VwclosingbalanceBranchListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title={$t('loanSummary')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-12 md:col-3 comp-grid" >
                    <div className="p-3 mb-3">
                        <DataSource onLoad={(options) => setFilterOptions('branchcode', options)}  apiPath="components_data/branchcode_option_list_2"  >
                            {
                            ({ response }) => 
                            <>
                            <div className="">
                                <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'branchcode', e.value)} value={filters.branchcode.value} optionLabel="label" optionValue="value" options={filters.branchcode.options} placeholder={$t('selectABranch')} >
                                </Dropdown>
                            </div>
                            </>
                            }
                        </DataSource>
                    </div>
                </div>
                <div className="col-12 md:col-3 comp-grid" >
                    <div className="p-3 mb-3">
                        <DataSource onLoad={(options) => setFilterOptions('groupname', options)}  apiPath="components_data/groupname_option_list"  >
                            {
                            ({ response }) => 
                            <>
                            <div className="">
                                <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'groupname', e.value)} value={filters.groupname.value} optionLabel="label" optionValue="value" options={filters.groupname.options} placeholder={$t('selectAGroup')} >
                                </Dropdown>
                            </div>
                            </>
                            }
                        </DataSource>
                    </div>
                </div>
                <div className="col-12 md:col-3 " >
                    <span className="p-input-icon-left w-full">
                    <i className="pi pi-search" />
                    <InputText placeholder={$t('search')} className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                    </span>
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container-fluid">
            <div className="grid ">
                <div className="col comp-grid" >
                    <FilterTags filterController={filterController} />
                    <div >
                        <PageBreadcrumbs />
                        <div className="grid ">
                            <div className="col">
                                <div className="page-records">
                                    <DataTable 
                                        lazy={true} 
                                        loading={loading} 
                                        value={records} 
                                        dataKey="loanaccountno" 
                                        sortField={sortBy} 
                                        sortOrder={sortOrder} 
                                        onSort={onSort}
                                        className=" p-datatable-sm" 
                                        stripedRows={true}
                                        showGridlines={false} 
                                        rowHover={true} 
                                        responsiveLayout="stack" 
                                        emptyMessage={<EmptyRecordMessage />} 
                                        >
                                        {/*PageComponentStart*/}
                                        <Column headerStyle={{width: '3rem'}} field=""  body={MasterDetailBtnTemplate}  ></Column>
                                        <Column  field="loanaccountno" header={$t('loanaccountno')}  sortable={true} ></Column>
                                        <Column  field="memberid" header={$t('memberid')}  sortable={true} ></Column>
                                        <Column  field="membername" header={$t('membername')}  sortable={true} ></Column>
                                        <Column  field="branchcode" header={$t('branchcode')}  sortable={true} ></Column>
                                        <Column  field="groupname" header={$t('groupname')}  sortable={true} ></Column>
                                        <Column  field="due" header={$t('due')}  sortable={true} ></Column>
                                        <Column  field="interest" header={$t('interest')}  sortable={true} ></Column>
                                        <Column  field="payment" header={$t('payment')}  sortable={true} ></Column>
                                        <Column  field="balance" header={$t('balance')}  sortable={true} ></Column>
                                        <Column  field="ledger_balance" header={$t('ledgerBalance')}  sortable={true} ></Column>
                                        <Column  field="overdue" header={$t('overdue')}  sortable={true} ></Column>
                                        <Column  field="emidue" header={$t('emidue')}  sortable={true} ></Column>
                                        <Column  field="principalas" header={$t('principalas')}  sortable={true} ></Column>
                                        <Column  field="foreclose" header={$t('foreclose')}  sortable={true} ></Column>
                                        <Column  field="due_emi_no" header={$t('dueEmiNo')}  sortable={true} ></Column>
                                        <Column  field="paid_emi_no" header={$t('paidEmiNo')}  sortable={true} ></Column>
                                        <Column  field="tot_emi_due" header={$t('totEmiDue')}  sortable={true} ></Column>
                                        <Column  field="ac_closed" header={$t('acClosed')}  sortable={true} ></Column>
                                        <Column  field="users_phonenumber" header={$t('usersPhonenumber')} body={PhonenumberTemplate} sortable={true} ></Column>
                                        <Column  field="users_userid" header={$t('usersUserid')} body={UseridTemplate} sortable={true} ></Column>
                                        <Column  field="mobileno" header={$t('mobileno')}  sortable={true} ></Column>
                                        {/*PageComponentEnd*/}
                                    </DataTable>
                                </div>
                                <PageFooter />
                            </div>
                            {
                            (currentRecord && !props.isSubPage) && 
                            <div className="col-12">
                                <div className="card p-0">
                                    <MasterDetailPages masterRecord={currentRecord} scrollIntoView={true} />
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>
	);
}
VwclosingbalanceBranchListPage.defaultProps = {
	primaryKey: '',
	pageName: 'vwclosingbalance',
	apiPath: 'vwclosingbalance/branch_list',
	routeName: 'vwclosingbalancebranch_list',
	msgBeforeDelete: $t('promptDeleteRecord'),
	msgTitle: $t('deleteRecord'),
	msgAfterDelete: $t('recordDeletedSuccessfully'),
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: true,
	importData: false,
	keepRecords: false,
	multiCheckbox: false,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 50,
}
export default VwclosingbalanceBranchListPage;
